import React from "react";
import { inject, observer } from "mobx-react";
import EmojiAnimationStore from "../_stores/emoji-animation/EmojiAnimationStore";
import LayoutStore from "library/core/stores/layout/LayoutStore";
import "./styles.scss";

type Props = {
  emojiAnimationStore?: EmojiAnimationStore;
  layoutStore?: LayoutStore;
};

const FloatingEmojiAnimation: React.ComponentType<Props> = ({
  emojiAnimationStore,
  layoutStore,
}) => {
  const { animatedEmojis } = emojiAnimationStore!;
  const isMobile = layoutStore?.isMobileScreenSize;
  const baseSize = isMobile ? 28 : 55;

  if (animatedEmojis.length === 0) return null;

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: "hidden",
        pointerEvents: "none",
        zIndex: 10000,
      }}>
      {animatedEmojis.map(emoji => {
        const size = baseSize * emoji.scale;
        return (
          <img
            key={emoji.id}
            src={emoji.emojiData}
            alt=''
            style={{
              position: "absolute",
              left: `${emoji.left}%`,
              bottom: `${emoji.bottom}%`,
              width: size,
              height: size,
              zIndex: emoji.zIndex,
              pointerEvents: "none",
              animation: `emojiFloat ${emoji.duration}s ease-out forwards`,
              "--emoji-float-y": `-${emoji.topDistance}px`,
              "--emoji-float-x": `${emoji.drift}px`,
              "--emoji-float-r": `${emoji.rotation}deg`,
            } as React.CSSProperties}
          />
        );
      })}
    </div>
  );
};

export default inject(
  "emojiAnimationStore",
  "layoutStore"
)(observer(FloatingEmojiAnimation));
